import { createSelector } from '@reduxjs/toolkit';

import { selectAppConfig } from '../config/selectAppConfig';
import { selectLocale } from '../i18n/selectLocale';

export const selectTelegramChannel = createSelector(
  [selectAppConfig, selectLocale],
  ({ telegramChannelMapping }, locale) => (locale ? telegramChannelMapping[locale] : null),
);
